import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import DatePicker from 'react-datepicker'
import { CustomInput } from 'reactstrap'
import { FONTS } from '../../../../constants'

export const LOBOverviewButton = class extends React.Component {
  render() {
    const lobs = [{ name: 'All', _id: '' }, ...get(this.props, 'lobs', [])]
    const startDateOverview = get(this.props, 'startDateOverview')
    const endDateOverview = get(this.props, 'endDateOverview')
    const lobOverview = get(this.props, 'lobOverview')
    const handleInputOverview = get(this.props, 'handleInputOverview')
    const location = get(this.props, 'location', '')
    const path = get(this.props, 'path', '')
    switch (location) {
      case `/efficiency_resource/lob/${path}` : {
        return null
      }
      default: {
        return (
          /* eslint no-underscore-dangle: 0 */
          <Buttons>
            <CustomDatePicker
              autoComplete='off'
              onChange={ (e) => handleInputOverview('start_date', e) }
              name="start_date"
              placeholderText='DD/MM/YYYY'
              selected={ startDateOverview }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
            />
            <CustomDatePicker
              autoComplete='off'
              onChange={ (e) => handleInputOverview('end_date', e) }
              name="end_date"
              placeholderText='DD/MM/YYYY'
              selected={ endDateOverview }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
            />
            <CustomInputField
              type='select'
              name='employee_level'
              value={ lobOverview }
              onChange={ (e) => handleInputOverview('lob', e) }
            >
              { orderBy(lobs, 'name', 'asc').map((g) =>
                <option key={ shortid() } value={ g._id }>{ g.name }</option>
              ) }
            </CustomInputField>
          </Buttons>
        )
      }
    }
  }
}

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  width: 30%;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const CustomDatePicker = styled(DatePicker)`
  width : 120px;
  height : 30px;
  padding-left: 5%;
  margin-left: 10px;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const CustomInputField = styled(CustomInput)`
  width : 120px;
  height : 30px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab/button-group/lob-overview.js